import React from 'react';
import axios from 'axios';
import { useForm, FormProvider } from "react-hook-form";
import Input from '../../Elements/Input/Input';
import InputColor from '../../Elements/Input/InputColor';
import elements from '../../Elements/elements'
import '../../Elements/style.css'
import Modal from '../../Elements/Modal/Modal';




const WineEdit = ({ pageTitle, pageItem, accessor }: any) => {
  // ...

  const [input, setInput] = React.useState({
    nome: '',
    tipo: '',
    casta: '',
    pontuacao: '',
    produtor: '',
    regiao: '',
    quinta: '',
    formato: '',
    anoColheita: '',
    enologo: '',
    preco: '',
    localCompra: '',
    dataCompra: '',
    quantidade: '',
    estado: '',
    garrafeira: '',
    secao: '',
    notasProva: '',
    prontoParaBeber: ''
  })
  // ...
  React.useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/wines/${window.location.pathname.split("/")[window.location.pathname.split("/").length - 1]}`).then((response) => {
      setInput(response.data)
      console.log(response.data);
      setPicture(response.data.photoWine);
      if (response.data.photoWine) {
        const b64encoded = Buffer.from(response.data.photoWine.buffer.data).toString('base64')
        setPreviewImg('data:image/jpeg;base64,' + b64encoded)
      }


    })
  }, []);
  // modal mensagem de envio
  const [modal, setModal] = React.useState({ ativo: false, message: '', error: false })
  // ... Iniciando contexto do React Hooks Forms
  const methods = useForm();
  // ... 
  const onSubmit = (data: any) => {
    //  
    if (picture === null) {
      setCheckImg({ ...checkImg, error: true, empty: true })
      return false
    }
    if (picture.size >= 5000000) {
      setCheckImg({ ...checkImg, error: true, size: true })
      return false
    }
    if (picture.type !== 'image/jpeg' && picture.type !== 'image/png' && picture.mimetype !== "image/jpeg" && picture.mimetype !== "image/png") {
      setCheckImg({ ...checkImg, error: true, format: true })
      return false
    }


    setModal({ ativo: true, message: 'Enviando...', error: false })

    const postData = new FormData() as any;

    postData.append('data', JSON.stringify(data));
    postData.append('picture', picture);

    // ...
    axios
      .put(`${process.env.REACT_APP_API_URL}/wines/${window.location.pathname.split("/")[window.location.pathname.split("/").length - 1]}`, postData)
      .then((response) => {
        if (response.status === 200) {
          setModal({ ativo: true, message: 'Enviado com sucesso', error: false })
        } else {
          setModal({ ativo: true, message: 'Ocorreu um erro interno ' + response.status, error: true })
        }
      })
      .catch(errorMsg => {
        setModal({ ativo: true, message: 'Ocorreu um erro de conexão com o servidor ' + errorMsg, error: true })
      })

  }


  // ... Mostrar imagem que vai ser enviada
  const [picture, setPicture] = React.useState<any>(null);
  const [previewImg, setPreviewImg] = React.useState<any>(null);
  const [checkImg, setCheckImg] = React.useState<any>({ error: false, empty: false, size: false, format: false });
  function onChangePicture(e: any) {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      const reader = new FileReader() as any;
      reader.readAsDataURL(e.target.files[0]);
      reader.addEventListener("load", () => {
        setPreviewImg(reader.result);
        console.log(e.target.files[0])
        setCheckImg({ error: false, empty: false, size: false, format: false })
      });


    }
  }

  return (
    <>
      <FormProvider {...methods} >
        <form onSubmit={methods.handleSubmit(onSubmit)} className="realtive">
          <div className="grid grid-cols-8 gap-8 w-full">
            {/* img */}
            <div className="lg:col-span-2 p-2 col-span-8 w-full text-center outer-img relative">
              <div className={`container-img relative z-10 rounded-xl ${(checkImg.error) && 'border-2 '}`}>
                {checkImg.error && (<p className="text-red-500 whitespace-nowrap absolute z-10 -inset-5">
                  {(checkImg.empty && ('Campo necessário'))}
                  {(checkImg.size && ('Imagem maior que 5mb'))}
                  {(checkImg.format && ('Imagem precisa estar em formato JPEG pu PNG'))}
                </p>)}
                <input id="image" className="w-full z-20 rounded-xl sticky w-full top-0 right-0" onChange={onChangePicture} type="file">
                </input>
                <p className="text-image-upload absolute block right-1/2 top-1/2 transform translate-x-1/2 -translate-y-1/2 ">Arraste e solte<br /> ou clique para adicionar</p>
                {(previewImg) && (<img alt="wine img" className="absolute img-uploaded z-0 block z-0 right-1/2 top-1/2 transform translate-x-1/2 -translate-y-1/2 absolute lg:max-h-64" src={previewImg} />)}
              </div>
              <label className="" htmlFor="image">
                Imagem em JPEG ou PNG até 5mb
              </label>
            </div>
            {/* first row */}
            <div className="lg:col-span-3 col-span-8 w-full relative">
              <Input element={elements.nome} input={(input.nome) ? (input.nome) : (null)} />
            </div>
            <div className="lg:col-span-3 col-span-8 w-full relative">
              <Input element={elements.tipo} input={input.tipo} />
            </div>
            {/* second row */}
            <div className="lg:col-span-3 col-span-8 w-full relative">
              <Input element={elements.casta} input={input.casta} />
            </div>
            <div className="lg:col-span-1 col-span-8 w-full relative">
              <Input element={elements.pontuacao} input={input.pontuacao} />
            </div>
            <br />
            {/* third row */}
            <div className="lg:col-span-2 lg:mt-8 col-span-8  w-full relative">
              <Input element={elements.produtor} input={input.produtor} />
            </div>
            <div className="lg:col-span-2 lg:mt-8 col-span-8 w-full relative">
              <Input element={elements.regiao} input={input.regiao} />
            </div>
            <div className="lg:col-span-2 lg:mt-8 col-span-8 w-full relative">
              <Input element={elements.quinta} input={input.quinta} />
            </div>
            <br className="lg:hidden block" />
            {/* fourth row */}
            <div className="lg:col-span-2 lg:mb-8 col-span-8 w-full relative">
              <Input element={elements.formato} input={input.formato} />
            </div>
            <div className="lg:col-span-2 lg:mb-8 col-span-4 w-full relative">
              <Input element={elements.anoColheita} input={input.anoColheita} />
            </div>
            <div className="lg:col-span-2 lg:mb-8 col-span-8 w-full relative">
              <Input element={elements.enologo} input={input.enologo} />
            </div>
            <br className="lg:hidden block" />
            {/* fifth row */}
            <div className="lg:col-span-1 lg:my-4 col-span-8 w-full relative preco">
              <Input element={elements.preco} input={input.preco} />
            </div>
            <div className="lg:col-span-3 lg:my-4 col-span-8 w-full relative">
              <Input element={elements.localCompra} input={input.localCompra} />
            </div>
            <div className="lg:col-span-1 lg:my-4 col-span-4 w-full relative">
              <Input element={elements.dataCompra} input={input.dataCompra} />
            </div>
            <div className="lg:col-span-1 lg:my-4 col-span-4 w-full relative">
              <Input element={elements.quantidade} input={input.quantidade} />
            </div>
            <br className="lg:hidden block" />
            {/* sixth row */}
            <div className="lg:col-span-2 lg:my-4 col-span-8 w-full relative">
              <InputColor element={elements.estado} input={input.estado} />
            </div>
            <div className="lg:col-span-2 lg:my-4 col-span-8 w-full relative">
              <Input element={elements.garrafeira} input={input.garrafeira} />
            </div>
            <div className="lg:col-span-2 lg:my-4 col-span-8 w-full relative">
              <Input element={elements.secao} input={input.secao} />
            </div>
            <br className="lg:hidden block" />
            {/* seventh row */}
            <div className="lg:col-span-1 lg:my-4 col-span-4 w-full relative">
              <Input element={elements.prontoParaBeber} input={input.prontoParaBeber} />
            </div>
            <div className="lg:col-span-5 lg:my-4 col-span-8 w-full relative">
              <Input element={elements.notasProva} input={input.notasProva} />
            </div>
            <div className="lg:hidden col-span-8" />
            {/* eighth row - Call to action*/}
            <a className="lg:col-span-1 flex rounded-md col-span-4 button cancel " href="/wines">
              <button type="button" className="text-base m-auto">
                CANCELAR
              </button>
            </a>
            <button className="lg:col-span-1 col-span-4 py-3 px-0 rounded-md font-bold text-base button send" type="submit">
              EDITAR
            </button>
          </div>
        </form>
      </FormProvider>
      {(modal.ativo) ? (<Modal setContent={setModal} content={modal} />) : (null)}
    </>
  )
};
export default WineEdit;



